module.exports = __webpack_public_path__ + "img/tradex.9680b9c2.png";